import type { View } from './engine/types'

export function projectedCellKey(view: View, lineKey: string, t: number): string {
  return `${view}:${lineKey}:${t}`
}

export function historicalCellKey(view: View, lineKey: string, t: number): string {
  return `${view}:${lineKey}:${t}`
}

export function labelCellKey(view: View, lineKey: string): string {
  return `${view}:${lineKey}:label`
}

export function methodologyCellKey(view: View, lineKey: string): string {
  return `${view}:${lineKey}:methodology`
}

export function isSharedNoteCellKey(cellKey: string): boolean {
  const period = cellKey.split(':').at(-1) ?? ''
  const t = Number(period)
  return Number.isFinite(t) && t <= 0
}
